function initAudioPlayer() {
  const audio = document.getElementById("background-music");
  const playPauseBtn = document.getElementById("play-pause-btn");
  const icon = playPauseBtn.querySelector("i");

  // musical notes
  const musicalNotes = document.querySelector(".musical-notes");

  // avatar
  const speakerImage = document.getElementById("speaker-image");

  function canAutoplay() {
    return new Promise((resolve) => {
      const tempAudio = document.createElement("audio");
      tempAudio.src =
        "data:audio/mpeg;base64,/+MYxAAAAANIAAAAAExBTUUzLjk4LjIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA";
      tempAudio
        .play()
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          resolve(false);
        });
    });
  }

  canAutoplay().then((canAutoplay) => {
    if (canAutoplay) {
      audio.play().catch(() => {
        console.log("Auto-play was prevented");
      });
      icon.classList.remove("fa-play");
      icon.classList.add("fa-pause");
    } else {
      console.log("Auto-play is not allowed");
    }
  });

  playPauseBtn.addEventListener("click", function () {
    if (audio.paused) {
      audio.play();
      icon.classList.remove("fa-play");
      icon.classList.add("fa-pause");
      speakerImage.classList.add("rotating");
      musicalNotes.classList.add("active");
    } else {
      audio.pause();
      icon.classList.remove("fa-pause");
      icon.classList.add("fa-play");
      speakerImage.classList.remove("rotating");
      musicalNotes.classList.remove("active");
    }
  });

  audio.addEventListener("ended", function () {
    playPauseBtn.classList.remove("fa-pause");
    playPauseBtn.classList.add("fa-play");
    musicalNotes.classList.remove("active");
  });
}

document.addEventListener("DOMContentLoaded", initAudioPlayer);
